export default "__VITE_ASSET__DFAsaSy8__"